import { render, staticRenderFns } from "./EquipItem.vue?vue&type=template&id=9aa36f4e&scoped=true"
import script from "./EquipItem.vue?vue&type=script&lang=js"
export * from "./EquipItem.vue?vue&type=script&lang=js"
import style0 from "./EquipItem.vue?vue&type=style&index=0&id=9aa36f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa36f4e",
  null
  
)

export default component.exports